import { render, staticRenderFns } from "./FixedMealDeal.vue?vue&type=template&id=7feb5956&scoped=true&"
import script from "./FixedMealDeal.vue?vue&type=script&lang=js&"
export * from "./FixedMealDeal.vue?vue&type=script&lang=js&"
import style0 from "./FixedMealDeal.vue?vue&type=style&index=0&id=7feb5956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feb5956",
  null
  
)

export default component.exports